// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 178) return "content/plugin-kpi-rig-floor/f5e5c142c61b5fe9bc444af651098c09.js";
	if (chunkId === 283) return "content/plugin-kpi-rig-floor/4b31bf2bef8039a6691281fab971192b.js";
	if (chunkId === 182) return "content/plugin-kpi-rig-floor/d0435e6ff7bd59b98a93f692e9b8230c.js";
	if (chunkId === 233) return "content/plugin-kpi-rig-floor/b94dee47622a66253fcceabeed6455db.js";
	// return url for filenames based on template
	return undefined;
};